import RoleHome from '../RoleHome';

export default function BillingClerkPage() {
  return (
    <RoleHome
      title="Billing clerk"
      description="Patient billing, revenue visibility, and queue."
    />
  );
}
